import { styled } from '@mui/material';
import Box from '@mui/material/Box/Box';
import { sizing, SizingProps } from '@mui/system';
import { FC, ReactNode } from 'react';
import { OnClick } from '../../../common/model/EventModels';
import { Button } from '../../buttons/Button';
import { Body1, Subtitle1 } from '../../typography/TextStyles';
import { BrandedPlusIcon } from '../../icons/brandedIcons';
import { Card } from './Card';

const StyledCard = styled(Card)`
  ${sizing}
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: default;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;

type Props = SizingProps & {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onClick?: OnClick;
  buttonComponent?: ReactNode;
  noOutline?: boolean;
};

export const EmptyCard: FC<Props> = ({
  title,
  subtitle,
  buttonText,
  onClick,
  buttonComponent,
  height = '18rem',
  ...rest
}) => {
  const shouldShowButton = !!buttonComponent || (!!onClick && !!buttonText);
  const marginLeftRight = { xs: 4, lg: 2 };

  const ButtonComponent = buttonComponent ? (
    <Box mt={3} px={2}>
      {buttonComponent}
    </Box>
  ) : (
    <Button mt={3} variant="contained" color="primary" onClick={onClick} endIcon={<BrandedPlusIcon color="white" />}>
      {buttonText}
    </Button>
  );

  return (
    <StyledCard height={height} {...rest}>
      {title && (
        <Subtitle1 maxWidth="32rem" align="center" mx={marginLeftRight} color="textSecondary" component="h2">
          {title}
        </Subtitle1>
      )}
      {subtitle && (
        <Body1 maxWidth="32rem" align="center" mx={marginLeftRight} pt={2} color="textSecondary">
          {subtitle}
        </Body1>
      )}
      {shouldShowButton && ButtonComponent}
    </StyledCard>
  );
};
